import * as React from "react"

function SearchSnapshot(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 350" {...props}>
      <style>
        {
          ".search-snapshot_st2{fill:#00aeef}.search-snapshot_st3{fill:#fff}.search-snapshot_st4{fill:#e9ecef}.search-snapshot_st5{fill:#c1c6cb}.search-snapshot_st6{fill:#1eca8a}.search-snapshot_st7{fill:none;stroke:#e9ecef;stroke-miterlimit:10}.search-snapshot_st8{fill:#7c8bdf}.search-snapshot_st9{fill:#d27a7b}.search-snapshot_st10{fill:#efc621}"
        }
      </style>
      <g id="search-snapshot_Guides_and_Back_00000084529498973680906690000002728537902753595822_">
        <path
          className="search-snapshot_st2"
          d="M26.3 58.7c22.9-35.1 74-38 116-39.7 55-2.4 102.3 11.6 194.8 39.7 145.3 44.1 218.4 67.1 242.8 116 4.2 8.4 14.2 29.2 8.1 51.5-8 29-38.9 44.5-67.8 56-83.2 33.3-150.2 60.1-245 45-41.3-6.7-184.6-36.8-239.1-149.9-7.5-15.7-37-76.9-9.8-118.6z"
        />
        <path className="search-snapshot_st3" d="M50 50h500v250H50z" />
      </g>
      <g id="search-snapshot_Page_Content_00000168075077691059184270000015150310478273558704_">
        <path
          className="search-snapshot_st3"
          d="M86.2 92.5c-2 0-3.7-1.7-3.7-3.7V72.3c0-2 1.7-3.7 3.7-3.7h178.6c2 0 3.7 1.7 3.7 3.7v16.6c0 2-1.7 3.7-3.7 3.7H86.2z"
        />
        <path
          className="search-snapshot_st4"
          d="M264.8 69c1.8 0 3.2 1.4 3.2 3.2v16.6c0 1.8-1.4 3.2-3.2 3.2H86.2c-1.8 0-3.2-1.4-3.2-3.2V72.3c0-1.8 1.4-3.2 3.2-3.2h178.6m0-1.1H86.2c-2.3 0-4.2 1.9-4.2 4.2v16.6c0 2.3 1.9 4.2 4.2 4.2h178.6c2.3 0 4.2-1.9 4.2-4.2V72.3c0-2.4-1.9-4.3-4.2-4.3zM86 281.5c-1.9 0-3.5-1.6-3.5-3.5V107c0-1.9 1.6-3.5 3.5-3.5h428.1c1.9 0 3.5 1.6 3.5 3.5v171c0 1.9-1.6 3.5-3.5 3.5H86z"
        />
        <path
          className="search-snapshot_st4"
          d="M514.2 104c1.7 0 3 1.3 3 3v171c0 1.7-1.3 3-3 3H86c-1.7 0-3-1.3-3-3V107c0-1.7 1.3-3 3-3h428.2m0-1H86c-2.2 0-4 1.8-4 4v171c0 2.2 1.8 4 4 4h428.1c2.2 0 4-1.8 4-4V107c.1-2.2-1.7-4-3.9-4z"
        />
        <path className="search-snapshot_st3" d="M218.5 144h288v134.7h-288z" />
        <path
          className="search-snapshot_st4"
          d="M506 144.5v133.7H219V144.5h287m1-1H218v135.7h289V143.5z"
        />
        <path
          className="search-snapshot_st5"
          d="M92.3 111.8H213v8.6H92.3zM92.3 126.8H150v8.6H92.3zM92.3 75.8H176v8.6H92.3z"
        />
        <path
          className="search-snapshot_st6"
          d="M295 93h-22c-2.2 0-4-1.8-4-4V72c0-2.2 1.8-4 4-4h22c2.2 0 4 1.8 4 4v17c0 2.2-1.8 4-4 4z"
        />
        <path
          className="search-snapshot_st2"
          d="M383 93h-44c-2.2 0-4-1.8-4-4V72c0-2.2 1.8-4 4-4h44c2.2 0 4 1.8 4 4v17c0 2.2-1.8 4-4 4zM326.8 83l-1.6-.9c.2-.9.2-1.8 0-2.6l1.6-.9c.2-.1.3-.3.2-.5-.4-1.3-1.1-2.5-2.1-3.6-.1-.2-.4-.2-.6-.1l-1.6.9c-.7-.6-1.4-1-2.3-1.3v-1.8c0-.2-.1-.4-.4-.4-1.4-.3-2.8-.3-4.1 0-.2 0-.4.2-.4.4V74c-.8.3-1.6.7-2.3 1.3l-1.6-.9c-.2-.1-.4-.1-.6.1-.9 1-1.6 2.2-2.1 3.6-.1.2 0 .4.2.5l1.6.9c-.2.9-.2 1.8 0 2.6l-1.6.9c-.2.1-.3.3-.2.5.4 1.3 1.1 2.5 2.1 3.6.1.2.4.2.6.1l1.6-.9c.7.6 1.4 1 2.3 1.3v1.8c0 .2.1.4.4.4 1.4.3 2.8.3 4.1 0 .2 0 .4-.2.4-.4v-1.8c.8-.3 1.6-.7 2.3-1.3l1.6.9c.2.1.4.1.6-.1.9-1 1.6-2.2 2.1-3.6.1-.2 0-.4-.2-.5zm-8.7.7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"
        />
        <path className="search-snapshot_st3" d="M92.5 143.8h117v134.7h-117z" />
        <path
          className="search-snapshot_st4"
          d="M209 144.3V278H93V144.3h116m1-1H92V279h118V143.3z"
        />
        <path
          className="search-snapshot_st7"
          d="M184.4 143.3V279M218 163.8h289M218 183.5h289M218 202.5h289M240.5 143.3V279M312 143.3V279M331.5 143.3V279M351 143.3V279M370.5 143.3V279M390 143.3V279M409.5 143.3V279M429 143.3V279M448.5 143.3V279M468 143.3V279M487.5 143.3V279"
        />
        <path
          className="search-snapshot_st5"
          d="M97.7 149.6H119v8.6H97.7zM188.7 149.6H206v8.6h-17.3zM221.7 149.6H236v8.6h-14.3zM221.7 169.6h9.3v8.6h-9.3zM221.7 188.6h9.3v8.6h-9.3zM221.7 207.6h9.3v8.6h-9.3zM221.7 226.6h9.3v8.6h-9.3zM221.7 245.6h9.3v8.6h-9.3zM221.7 264.6h9.3v8.6h-9.3zM244.7 169.6H292v8.6h-47.3zM244.7 188.6H271v8.6h-26.3zM244.7 207.6H280v8.6h-35.3zM244.7 226.6H272v8.6h-27.3zM244.7 245.6H258v8.6h-13.3zM244.7 264.6H295v8.6h-50.3zM244.7 149.6H275v8.6h-30.3zM317.7 149.6h8.3v8.6h-8.3zM337.2 149.6h8.3v8.6h-8.3zM356.6 149.6h8.3v8.6h-8.3zM376.1 149.6h8.3v8.6h-8.3zM395.5 149.6h8.3v8.6h-8.3zM415 149.6h8.3v8.6H415zM434.4 149.6h8.3v8.6h-8.3zM453.9 149.6h8.3v8.6h-8.3zM473.3 149.6h8.3v8.6h-8.3zM492.7 149.6h8.3v8.6h-8.3zM97.7 172.1H153v8.6H97.7zM97.7 196.4H125v8.6H97.7z"
        />
        <path className="search-snapshot_st7" d="M218 221.7h289" />
        <path className="search-snapshot_st5" d="M97.7 220.4H121v8.6H97.7z" />
        <path className="search-snapshot_st7" d="M218 240.3h289M218 259.5h289" />
        <path
          className="search-snapshot_st5"
          d="M97.7 244.4H142v8.6H97.7zM97.7 268.4H134v8.6H97.7z"
        />
        <path
          className="search-snapshot_st7"
          d="M91.5 163.8H210M91.5 188.5H210M90.5 213.1H209M90.5 236.7H209M91.5 260.9H210"
        />
        <path
          className="search-snapshot_st2"
          d="M185 164h24v24h-24zM313 165h17v18h-17zM333 165h17v18h-17zM352 165h17v18h-17zM372 165h17v18h-17z"
        />
        <path className="search-snapshot_st6" d="M391 165h17v18h-17z" />
        <path className="search-snapshot_st8" d="M411 165h17v18h-17z" />
        <path
          className="search-snapshot_st2"
          d="M430 165h17v18h-17zM450 165h17v18h-17zM469 165h17v18h-17z"
        />
        <path className="search-snapshot_st9" d="M488 165h17v18h-17z" />
        <path className="search-snapshot_st10" d="M313 184h17v18h-17z" />
        <path className="search-snapshot_st8" d="M333 184h17v18h-17z" />
        <path className="search-snapshot_st6" d="M352 184h17v18h-17z" />
        <path className="search-snapshot_st10" d="M372 184h17v18h-17z" />
        <path className="search-snapshot_st8" d="M391 184h17v18h-17z" />
        <path className="search-snapshot_st10" d="M411 184h17v18h-17z" />
        <path className="search-snapshot_st9" d="M430 184h17v18h-17z" />
        <path className="search-snapshot_st8" d="M450 184h17v18h-17z" />
        <path className="search-snapshot_st10" d="M469 184h17v18h-17z" />
        <path
          className="search-snapshot_st9"
          d="M488 184h17v18h-17zM313 203h17v18h-17zM333 203h17v18h-17zM352 203h17v18h-17z"
        />
        <path className="search-snapshot_st10" d="M372 203h17v18h-17z" />
        <path
          className="search-snapshot_st9"
          d="M391 203h17v18h-17zM411 203h17v18h-17z"
        />
        <path className="search-snapshot_st8" d="M430 203h17v18h-17z" />
        <path className="search-snapshot_st10" d="M450 203h17v18h-17z" />
        <path className="search-snapshot_st9" d="M469 203h17v18h-17z" />
        <path className="search-snapshot_st2" d="M488 203h17v18h-17z" />
        <path className="search-snapshot_st9" d="M313 222h17v18h-17z" />
        <path className="search-snapshot_st6" d="M333 222h17v18h-17z" />
        <path className="search-snapshot_st8" d="M352 222h17v18h-17z" />
        <path className="search-snapshot_st10" d="M372 222h17v18h-17z" />
        <path className="search-snapshot_st6" d="M391 222h17v18h-17z" />
        <path className="search-snapshot_st2" d="M411 222h17v18h-17z" />
        <path className="search-snapshot_st8" d="M430 222h17v18h-17z" />
        <path className="search-snapshot_st10" d="M450 222h17v18h-17z" />
        <path className="search-snapshot_st2" d="M469 222h17v18h-17z" />
        <path className="search-snapshot_st6" d="M488 222h17v18h-17z" />
        <path className="search-snapshot_st10" d="M313 241h17v18h-17z" />
        <path className="search-snapshot_st8" d="M333 241h17v18h-17z" />
        <path className="search-snapshot_st6" d="M352 241h17v18h-17z" />
        <path
          className="search-snapshot_st9"
          d="M372 241h17v18h-17zM391 241h17v18h-17z"
        />
        <path
          className="search-snapshot_st2"
          d="M411 241h17v18h-17zM430 241h17v18h-17zM450 241h17v18h-17z"
        />
        <path className="search-snapshot_st9" d="M469 241h17v18h-17z" />
        <path className="search-snapshot_st2" d="M488 241h17v18h-17z" />
        <path className="search-snapshot_st6" d="M313 260h17v18h-17z" />
        <path className="search-snapshot_st9" d="M333 260h17v18h-17z" />
        <path className="search-snapshot_st8" d="M352 260h17v18h-17z" />
        <path className="search-snapshot_st10" d="M372 260h17v18h-17z" />
        <path className="search-snapshot_st9" d="M391 260h17v18h-17z" />
        <path
          className="search-snapshot_st8"
          d="M411 260h17v18h-17zM430 260h17v18h-17z"
        />
        <path className="search-snapshot_st6" d="M450 260h17v18h-17z" />
        <path className="search-snapshot_st8" d="M469 260h17v18h-17z" />
        <path className="search-snapshot_st10" d="M488 260h17v18h-17z" />
        <path className="search-snapshot_st6" d="M185 189h24v24h-24z" />
        <path className="search-snapshot_st10" d="M185 214h24v22h-24z" />
        <path className="search-snapshot_st9" d="M185 237h24v24h-24z" />
        <path className="search-snapshot_st8" d="M185 262h24v16h-24z" />
      </g>
    </svg>
  )
}

export default SearchSnapshot
